// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__vdP0k","changeContent":"Spinner_changeContent__iBNOe"};